import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import Dialog from 'components/ReusableComponents/Dialog'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import { useEffect, useState } from 'react'
import CreatableSelect from 'react-select/creatable'
import { useToasts } from 'react-toast-notifications'
import widgetsApi from 'services/api/widgets'

import styles from './ExcludedPagesDialog.module.scss'

function normalizePageOption(p) {
  return typeof p === 'string' ? { value: p, label: p } : p
}

const ExcludedPagesDialog = ({ onClose, siteMap }) => {
  const [isLoading, setIsLoading] = useState(false)

  const [widgets, setWidgets] = useState(null)
  const { addToast } = useToasts()

  useEffect(() => {
    setIsLoading(true)

    widgetsApi.list
      .get()
      .then(response => {
        setWidgets(response.map(w => ({ ...w, data: JSON.parse(w.data) })))
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [])

  function setPagesToHide(pagesToHide) {
    if (!widgets?.length) return
    setWidgets(widgets.map(w => ({ ...w, data: { ...w.data, pagesToHide } })))
  }

  const pagesToHideRaw = widgets?.[0]?.data?.pagesToHide || []
  const pagesToHideNormalized = pagesToHideRaw.map(normalizePageOption)

  const siteMapOptions = (siteMap || []).map(page => ({ value: page, label: page }))
  const siteMapValues = (siteMap || []).slice()
  const customOptions = pagesToHideNormalized.filter(
    p => !siteMapValues.includes(p.value)
  )
  const options = [...siteMapOptions, ...customOptions]

  function saveChanges() {
    setIsLoading(true)
    widgetsApi.list
      .post({ data: widgets.map(w => ({ ...w, data: JSON.stringify(w.data) })) })
      .then(() => {
        onClose()
        addToast('Excluded pages are updated', { appearance: 'success' })
      })
      .catch(err => {
        addToast(`${err}`, {
          appearance: 'error',
          autoDismiss: true
        })
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  if (isLoading) {
    return (
      <Dialog>
        <LoadingIndicator white />
      </Dialog>
    )
  }

  return (
    <ConfirmationDialog
      title="Excluded pages"
      onClose={onClose}
      onConfirm={saveChanges}
      positiveMessage="Save changes"
      negativeMessage="Cancel"
      allowOverflow
      theme="blacklist"
      maxWidth={600}
    >
      <div className={styles.pagesToHideContainer}>
        <p className={styles.label}>Pages to hide the widgets</p>
        <CreatableSelect
          options={options}
          isMulti
          placeholder="Type page name..."
          value={pagesToHideNormalized}
          onChange={selected => setPagesToHide(selected || [])}
          onCreateOption={newOption =>
            setPagesToHide([
              ...pagesToHideNormalized,
              { value: newOption, label: newOption }
            ])
          }
          menuPortalTarget={document.body}
          menuPosition="fixed"
          styles={{
            menuPortal: base => ({ ...base, zIndex: 9999 })
          }}
        />
      </div>
    </ConfirmationDialog>
  )
}

export default ExcludedPagesDialog
